import React, { PureComponent } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import "./style.css";

export const LineChartComponent = ({ yAxis = true, data = [] }) => {
  if (!data.length) return <p>No hay datos diarios disponibles para el gráfico.</p>;
  class Component extends PureComponent {
    render() {
      return (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={400}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis dataKey="name" />
            {yAxis && <YAxis />}
            <Tooltip />

            <Line type="monotone" dataKey="ingresos" stroke="#0057FF" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="ventas" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      );
    }
  }
  return <Component />;
};
